import {
  getAllPastAppointments,
  getAllUpcommingAppointments,
} from '../../api/Appointments/appointments.api';
import {
  APPOINTMENTS_FAIL,
  GET_UPCOMMING_APPOINTMENTS,
  GET_PAST_APPOINTMENTS,
} from './types';

export const upcommingAppointments = () => {
  return async (dispatch) => {
    try {
      getAllUpcommingAppointments((appointments) => {
        dispatch(upcommingAppointmentSuccess(appointments));
      });
    } catch (error) {
      dispatch(appointmentsFail());
    }
  };
};

export const pastAppointments = () => {
  return async (dispatch) => {
    try {
      getAllPastAppointments((appointments) => {
        dispatch(pastAppointmentsSuccess(appointments));
      });
    } catch (error) {
      dispatch(appointmentsFail());
    }
  };
};

const upcommingAppointmentSuccess = (payload) => ({
  type: GET_UPCOMMING_APPOINTMENTS,
  payload,
});

const pastAppointmentsSuccess = (payload) => ({
  type: GET_PAST_APPOINTMENTS,
  payload,
});

const appointmentsFail = () => ({
  type: APPOINTMENTS_FAIL,
});
